/**
 * PublicCareRequestService
 * Anonymous (public) care/help request submission
 */
import { BaseService } from '../base/BaseService';
/**
 * Service for submitting public care/help requests (no authentication required)
 */
export class PublicCareRequestService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PublicCareRequestService.DEFAULT_SERVICE_PATH,
            basePath: PublicCareRequestService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Submit a public care/help request
     * @param request - The request submission payload
     * @returns Public care request receipt (reference + message)
     */
    async submit(request) {
        const response = await this.submitRaw(request);
        if (!response.data) {
            throw new Error('Failed to submit public care request');
        }
        return response.data;
    }
    /**
     * Submit a public care/help request with full response
     * @param request - The request submission payload
     * @returns ResponseData with public care request receipt
     */
    submitRaw(request) {
        const url = this.buildUrl();
        return this.http.post(url, request);
    }
}
PublicCareRequestService.DEFAULT_SERVICE_PATH = 'ac-counselling';
PublicCareRequestService.BASE_PATH = 'api/public/care-requests';
//# sourceMappingURL=PublicCareRequestService.js.map